// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;
const IS_TEST_ENV = import.meta.env.MODE === "test" || import.meta.env.VITEST;

interface GetSupabaseClientOptionsArgs {
  isTest?: boolean;
}

export const getSupabaseClientOptions = ({ isTest = IS_TEST_ENV }: GetSupabaseClientOptionsArgs = {}) => ({
  auth: isTest
    ? {
        persistSession: false,
        autoRefreshToken: false,
        detectSessionInUrl: false,
      }
    : {
        storage: window.localStorage,
        persistSession: true,
        autoRefreshToken: true,
      },
});

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(
  SUPABASE_URL,
  SUPABASE_PUBLISHABLE_KEY,
  getSupabaseClientOptions(),
);
